import { Card } from '@commenda/kakashi';
import { cn, formatNumberWithUniqueCommaPattern } from '@commenda/utils';

export interface FilterTab<T extends string> {
  id: T;
  label: string;
  count: number;
  tooltip?: string;
  textClassName?: string;
  countClassName?: string;
}

export interface FilterTabsProps<T extends string> {
  tabs: FilterTab<T>[];
  activeTab: T;
  onTabChange: (tab: T) => void;
}

const FilterTabCard = <T extends string>({
  tab,
  isActive,
  onClick,
}: {
  tab: FilterTab<T>;
  isActive: boolean;
  onClick: () => void;
}) => {
  return (
    <Card.Root
      _className={cn(
        'flex-col cursor-pointer flex-1 min-w-0 rounded-sm px-3 py-2 gap-none transition-colors hover:border-fg-brand',
        isActive && 'ring-2 ring-fg-brand'
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-sm">
        <span className="txt-small-regular text-text-tertiary">
          {tab.label}
        </span>
      </div>
      <span className="txt-extra-large-medium text-text-primary">
        {formatNumberWithUniqueCommaPattern(tab.count)}
      </span>
    </Card.Root>
  );
};

const FilterTabs = <T extends string>({
  tabs,
  activeTab,
  onTabChange,
}: FilterTabsProps<T>) => {
  return (
    <div className="flex items-stretch gap-md w-full">
      {tabs.map((tab) => (
        <FilterTabCard
          key={tab.id}
          tab={tab}
          isActive={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        />
      ))}
    </div>
  );
};

export { FilterTabs };
